import * as React from 'react';
import { navigate } from 'mydish-ui-util';
import { useHistory } from 'react-router-dom';
import '../css/buttons.sass';
import style2object from '../utils/style-object';
import formatter from '../utils/formatter-util';

export interface CampfireButtonProps {
  name: string;
  id: string;
  label: string;
  style?: string;
  focus?: boolean;
  onClick?: Function;
  onKeyDown?: Function;
  disabled?: boolean;
  color?: 'water' | 'blaze' | 'marshmallow' | 'coal';
  ghost?: boolean;
  frosty?: boolean;
  smol?: boolean;
  sendTo?: string;
  tel?: string;
  newWindow?: boolean;
  theme?: 'night' | 'day';
  title?: string;
  iconPath?: string;
  iconPosition?: 'left' | 'right';
  // accessibility prop for buttons used in Collapse panel
  ariaExpanded?: boolean;
}

export default function CampfireButton(props: CampfireButtonProps) {
  const history = useHistory();

  const {
    color = 'water',
    newWindow = false,
    theme = 'day',
    iconPosition = 'right'
  } = props;
  let className = `cta ${color} filled ${theme}`;
  if (props.ghost) {
    className = `${className.replace('filled', 'ghost')}`;
    if (props.frosty) {
      className = `${className} frosty`;
    }
  }
  if (props.smol) {
    className = `${className} smol`;
  }
  if (props.disabled) {
    className = `${className} disabled`;
  }
  if (!props.label) {
    className = `${className} no-label`;
  }

  const handleMouseDown = () => {
    const btn = document.getElementsByTagName('button');
    for (let i = 0, all = btn.length; i < all; i += 1) {
      btn[i].classList.add('using-mouse');
    }
  };

  const handleKeyDown = (e: any) => {
    if (e.keyCode === 9) {
      const btn = document.getElementsByTagName('button');
      for (let i = 0, all = btn.length; i < all; i++) {
        btn[i].classList.remove('using-mouse');
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);
  }, [props]);

  let ariaExpanded: 'true' | 'false' | undefined;
  let ariaControls: string | undefined;
  if (props.ariaExpanded !== undefined) {
    ariaExpanded = props.ariaExpanded === true ? 'true' : 'false';
    ariaControls = props.id;
  }

  return (
    <button
      type="button"
      title={props.title}
      id={props.id}
      disabled={props.disabled}
      style={props.style ? style2object(props.style) : {}}
      className={className}
      onMouseDown={(e: any) => {
        e.preventDefault();
      }}
      onKeyDown={(e: any) => {
        if (props.onKeyDown !== undefined) {
          props.onKeyDown(e);
        }
      }}
      onClick={(e: any) => {
        if (props.tel) {
          window.location.href = `tel: ${formatter({
            type: 'phone',
            value: props.tel,
            format: 'tel'
          })}`;
        }
        if (props.sendTo) {
          if (newWindow) {
            window.open(props.sendTo);
          } else {
            navigate(props.sendTo, history);
          }
        }
        if (props.onClick !== undefined) {
          props.onClick(e);
        }
      }}
      // accessibility attributes for buttons used inside collapse panel
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
    >
      {!!props.iconPath && !props.smol && iconPosition === 'left' && (
        <div
          className={`btn-icon ${iconPosition}`}
          style={{
            backgroundImage: `url(${props.iconPath})`
          }}
        >
          {' '}
        </div>
      )}
      <span>{props.label}</span>

      {!!props.iconPath && !props.smol && iconPosition === 'right' && (
        <div
          className={`btn-icon ${iconPosition}`}
          style={{
            backgroundImage: `url(${props.iconPath})`
          }}
        >
          {' '}
        </div>
      )}
    </button>
  );
}
